/**
 * Actions related to the Care Plus section of the new planbox.
 *
 * @package Qustodio\Theme
 */

const carePlus = () => {
  const infoToggle = () => {
    const selector = '.qusd-exp-planbox-care-plus__more-info.js-toggle-icon';
    const elements = Array.from(document.querySelectorAll(selector));
    elements.forEach((element) => {
      element.addEventListener('click', () => {
        element.classList.toggle('qusd-exp-planbox-care-plus__more-info--open');
      });
    });
  };

  return {
    init: infoToggle,
  };
};
export default carePlus();
